import { SearchInRange } from 'Pages/Project/Documents/Stores/DocumentsSearchStore';

/**
 * Returns radio button value in depend of post object configuration. 
 * Works together with radioButtonValueToSearchPostObject.ts
 */
export function searchPostObjectToRadioButtonValue(postObject: API_DocSearchReq) {
  let radioButtonValue: SearchInRange;
  if (postObject.folderId) {
    if (postObject.includeSubDirectories) {
      radioButtonValue = 'CURR_CHILDREN';
    } else {
      radioButtonValue = 'CURR_DIR';
    }
  } else {
    radioButtonValue = 'ALL';
  }
  return radioButtonValue;
}
